export default {
	title: 'Mes examens',
	icon: 'doctor-stethoscope-violet.svg',
	iconAucun: 'smile.svg',
	messageErreurAucun: 'Vous n\'avez aucun examen à faire ce mois-ci.',
	grossesse: {
		mois0: [
			{
				text: 'Examens de laboratoires : groupe sanguin,  dépistages de la toxoplasmose, de la  rubéole, de l\'hépatite B.'
			},
			{
				text: 'Recherche d\'agglutinines irrégulières.'
			},
			{
				text: 'Analyse d\'urine à la recherche de protéine ou de sucre.'
			},
			{
				text: 'Un frottis pourra être réalisé si je ne suis  pas à jour.'
			}
		],
		mois1: [
			{
				text: 'Examens de laboratoires : groupe sanguin,  dépistages de la toxoplasmose, de la  rubéole, de l\'hépatite B.'
			},
			{
				text: 'Recherche d\'agglutinines irrégulières.'
			},
			{
				text: 'Analyse d\'urine à la recherche de protéine ou de sucre.'
			},
			{
				text: 'Un frottis pourra être réalisé si je ne suis  pas à jour.'
			}
		],
		mois2: [
			{
				text: 'Examens de laboratoires : groupe sanguin,  dépistages de la toxoplasmose, de la  rubéole, de l\'hépatite B.'
			},
			{
				text: 'Recherche d\'agglutinines irrégulières.'
			},
			{
				text: 'Analyse d\'urine à la recherche de protéine ou de sucre.'
			},
			{
				text: 'Un frottis pourra être réalisé si je ne suis  pas à jour.'
			}
		],
		mois3: [
			{
				text: 'Dépistage de la toxoplasmose si le précédent était négatif.'
			},
			{
				text: 'Renouvellement de l\'analyse d\'urine à la recherche de protéine et de sucre.'
			},
			{
				text: 'Réalisation d\'un examen bucco-dentaire à partir du 4<sup>ème</sup> mois de grossesse et jusqu\'au 6<sup>ème</sup> mois après mon accouchement'
			}
		],
		mois4: [
			{
				text: 'Dépistage de la toxoplasmose si le précédent était négatif.'
			},
			{
				text: 'Renouvellement de l\'analyse d\'urine à la recherche de protéine et de sucre.'
			},
			{
				text: 'Réalisation d\'un examen bucco-dentaire à partir du 4<sup>ème</sup> mois de grossesse et jusqu\'au 6<sup>ème</sup> mois après mon accouchement'
			}
		],
		mois5: [
			{
				text: 'Dépistage de la toxoplasmose si le précédent était négatif.'
			},
			{
				text: 'Numération Formule Sanguine (NFS) pour comptabiliser le nombre de globules rouges, de globules blancs et de plaquettes dans mon sang.'
			},
			{
				text: 'Renouvellement de l\'analyse d\'urine à la recherche de protéine et de sucre.'
			},
			{
				text: 'Recherche d\'agglutinines irrégulières.'
			},
			{
				text: 'Réalisation d\'un examen bucco-dentaire à partir du 4<sup>ème</sup> mois de grossesse et jusqu\'au 6<sup>ème</sup> mois après mon accouchement'
			}
		],
		mois6: [
			{
				text: 'Dépistage de la toxoplasmose si le précédent était négatif.'
			},
			{
				text: 'Renouvellement de l\'analyse d\'urine à la recherche de protéine et de sucre.'
			},
			{
				text: 'Réalisation d\'un examen bucco-dentaire à partir du 4<sup>ème</sup> mois de grossesse et jusqu\'au 6<sup>ème</sup> mois après mon accouchement'
			}
		],
		mois7: [
			{
				text: 'Dépistage de la toxoplasmose si le précédent était négatif.'
			},
			{
				text: 'Renouvellement de l\'analyse d\'urine à la recherche de protéine et de sucre.'
			},

			{
				text: 'Recherche d\'agglutinines irrégulières.'
			},
			{
				text: 'Détermination de mon groupe sanguin s\'il n\'a pas déjà été réalisé.'
			},
			{
				text: 'Réalisation d\'un examen bucco-dentaire à partir du 4<sup>ème</sup> mois de grossesse et jusqu\'au 6<sup>ème</sup> mois après mon accouchement'
			}
		],
		mois8: [
			{
				text: 'Réalisation d\'un examen bucco-dentaire à partir du 4<sup>ème</sup> mois de grossesse et jusqu\'au 6<sup>ème</sup> mois après mon accouchement'
			}
		],
		mois9: [
			{
				text: 'Réalisation d\'un examen bucco-dentaire à partir du 4<sup>ème</sup> mois de grossesse et jusqu\'au 6<sup>ème</sup> mois après mon accouchement'
			}
		]
	}
};
